<template>
  <b-card>
    <b-card-header>
      <h2>Featured Causes</h2>
    </b-card-header>
    <b-card-body>
      <h3>Black Lives Matter Related</h3>
      <b-list-group>
          <b-list-group-item><a target="_blank" href="https://justiceforbreonna.org/">Justice for Beronna</a></b-list-group-item>
          <b-list-group-item><a target="_blank" href="https://www.gofundme.com/f/9v4q2-justice-for-breonna-taylor">Donate to the family of Breonna Taylor</a></b-list-group-item>
          <b-list-group-item><a target="_blank" href="https://www.change.org/p/adams-county-district-attorney-justice-for-elijah-mcclain-2">Justice for Elijah Mcclain</a></b-list-group-item>
          <b-list-group-item><a target="_blank" href="https://actionnetwork.org/fundraising/louisville-community-bail-fund/">Lousiville Community Bail Fund</a></b-list-group-item>
          <b-list-group-item><a target="_blank" href="https://www.gofundme.com/f/blmcovid">East Of The River Mutual Aid Fund</a></b-list-group-item>
          <b-list-group-item><a target="_blank" href="https://emancipatenc.org/freedom-fighter-bond-fund/">Freedom Fighter Bond Fund</a></b-list-group-item>
          <b-list-group-item><a target="_blank" href="https://www.gofundme.com/f/justicefordavidmcatee">David McAtee GoFundMe</a></b-list-group-item>
          <b-list-group-item><a target="_blank" href="https://www.gofundme.com/f/georgefloyd">Official George Floyd Memorial Fund</a></b-list-group-item>
          <b-list-group-item><a target="_blank" href="https://twitter.com/esmeatgrlpwr/status/1267771312107331584">Twitter thread of important petitions to sign</a></b-list-group-item>
          <b-list-group-item><a target="_blank" href="https://blacklivesmatters.carrd.co/">Additional Ways You Can Help</a></b-list-group-item>
      </b-list-group>
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  name: 'FeaturedCause',
  data () {
    return {
    }
  }
}</script>
<style scoped>
  h2, h3 {
    width: 85%;
    text-align: left;
  }

</style>
